import { FloatingDelayGroup } from "@floating-ui/react";
import { Outlet, ScrollRestoration } from "react-router";
import { Realm, RealmContext } from "~/util/Lang";

export default function SiteLayout(props: { realm: Realm }) {
  return (
    <FloatingDelayGroup delay={{ open: 150 }}>
      <RealmContext.Provider value={props.realm}>
        <Outlet />
        {SRV ? null : <ScrollRestoration />}
      </RealmContext.Provider>
    </FloatingDelayGroup>
  );
}
